module.exports = __webpack_public_path__ + "img/图像 39@2x.1aa6acbb.webp";